import { render, staticRenderFns } from "./lista-de-escolas.vue?vue&type=template&id=552ebf3c&scoped=true&"
import script from "./lista-de-escolas.vue?vue&type=script&lang=js&"
export * from "./lista-de-escolas.vue?vue&type=script&lang=js&"
import style0 from "./lista-de-escolas.vue?vue&type=style&index=0&id=552ebf3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552ebf3c",
  null
  
)

export default component.exports